module.exports = __webpack_public_path__ + "img/3b8aa8a.svg";